import { render } from "./FormulaireInfoSanteFFTRI.vue?vue&type=template&id=5fb4820b&scoped=true"
import script from "./FormulaireInfoSanteFFTRI.vue?vue&type=script&lang=js"
export * from "./FormulaireInfoSanteFFTRI.vue?vue&type=script&lang=js"

import "./FormulaireInfoSanteFFTRI.vue?vue&type=style&index=0&id=5fb4820b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb4820b"]])

export default __exports__